import { z } from 'zod';
// Per-concept founder action on a creative_drop card (s216).
// The drop card payload (creative-drop.ts) carries Mag's slate as
// an immutable record. The founder's per-concept verdict lives
// out-of-band in the creative_drop_concept_actions table; the FE
// reads the row map alongside the card so each concept renders
// with its current chip state.
//
// Three actions today:
//   - 'approved'      : founder explicitly OK'd; valid on
//                       needs_approval concepts.
//   - 'objected'      : founder vetoed; valid on any kind.
//   - 'auto_launched' : the A1 enforcer (s217) wrote this when
//                       deadlineIso elapsed without a founder
//                       action on an auto_launch_unless_objection
//                       concept. actorUserId is null on these
//                       rows. Counts as a silent-approval entry
//                       in the trust ledger (spec §5 A1→A0
//                       graduation mechanism).
export const dropConceptActionKindSchema = z.enum(['approved', 'objected', 'auto_launched']);
export const dropConceptActionSchema = z.object({
    conceptId: z.string().uuid(),
    action: dropConceptActionKindSchema,
    actedAt: z.string(),
});
/** Map shipped alongside each creative_drop card in the feed
 *  envelope. Keyed by conceptId for O(1) lookup at render time.
 *  Empty map = no actions yet. */
export const dropConceptActionMapSchema = z.record(z.string().uuid(), dropConceptActionSchema);
//# sourceMappingURL=creative-drop-actions.js.map